import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';


class QuickUpdatableComponent extends PureComponent {};

QuickUpdatableComponent.propTypes = {
    field: PropTypes.object.isRequired,
    required: PropTypes.bool,
};

export default QuickUpdatableComponent;